import { useContext } from 'react'

import { MODALS_ID } from '../constants'

import { ModalContext } from '../provider/modalProvider'

import { Alert } from '../components/alert'
import type { AlertProps } from '../components/alert/Alert'

export function useAlert() {
  const { openModal } = useContext(ModalContext)

  const openAlert = (props: AlertProps) => {
    openModal({ id: MODALS_ID.ALERT, Component: () => Alert(props) })
  }

  return openAlert
}
